'use client'
import React, { useEffect, useState } from 'react'
import { useGoRestAPI } from '@bitechsystems/services'
import {
  Card,
  Grid,
  Title,
  Group,
  Stack,
  ThemeIcon,
  Text,
  Button,
  Notification,
  ScrollArea,
} from '@mantine/core'
import { IconX } from '@tabler/icons-react'
import { useQuery } from '@tanstack/react-query'

import { FaSkullCrossbones } from 'react-icons/fa'
import { GrTestDesktop, GrUpgrade } from 'react-icons/gr'
import { MdPriorityHigh } from 'react-icons/md'
import { IT_Business } from '../../../types/models/DBBuffers'

export const WarningCard = ({ theme, classes }: any) => {
  const busAPI = useGoRestAPI<IT_Business>('t_business')
  const [hasWarnings, setHasWarnings] = useState(false)
  const busQuery = useQuery<Array<IT_Business> | null>({
    queryKey: [`warningcard_bus`],
    queryFn: () =>
      busAPI?.get([
        { type: 'simpleapi', name: 'simpleapi', value: '1' },
        {
          type: 'select-fields',
          name: 'select',
          value: `licenced,messagefrombitech,name,hyphencompanynumber,hyphenhumber`,
        },
        { type: 'limit', name: '', value: '1' },
        {
          type: 'cql-sel',
          name: 'currentversion',
          value: `(select v.newversion
          from version v
          where v.newversion is distinct from v.version
          )`,
        },
        {
          type: 'cql-sel',
          name: 'lastbackupdate',
          value: `(
            select b2.lastbackupdate
            from t_business b2
            where b2.lastbackupdate < (now() - '1 month'::interval)
              and nv(f_get_parms('disable_backup_warning')) in ('','0')
          )`,
        },
      ]),
    retry: 1,
  })

  useEffect(() => {
    if (
      busQuery.data?.[0]?.messagefrombitech ||
      (busQuery.data?.[0]?.currentversion ?? '') != '' ||
      (busQuery.data?.[0]?.licenced ?? 0) > 50 ||
      (busQuery.data?.[0]?.lastbackupdate ?? '') != ''
    ) {
      setHasWarnings(true)
    }
  }, [busQuery.data])

  if (!hasWarnings) {
    return <></>
  }

  return (
    <Card shadow={'xs'} mt={'lg'}>
      <Card.Section px={'xl'} py='xs' withBorder>
        <Group>
          <Title weight={600} order={5} color={theme.cardHeaderColor}>
            Notifications
          </Title>
          {/* <Button compact size='xs' variant='default' pr={'xs'}>
            Training
          </Button> */}
        </Group>
      </Card.Section>

      <Card.Section p={'xs'} withBorder>
        <Stack spacing={'xs'}>
          {(busQuery.data?.[0]?.messagefrombitech ?? '').length > 0 && (
            <Notification
              id='urgent_message'
              disallowClose
              icon={<MdPriorityHigh size={18} />}
              color='red'
              title='Urgent Notification From Bitech'
            >
              <ScrollArea style={{ maxHeight: '150px' }}>
                <pre
                  id='cla_urgent'
                  style={{ width: '100%', overflow: 'auto' }}
                >
                  {busQuery.data?.[0]?.messagefrombitech ?? ''}
                </pre>
              </ScrollArea>
            </Notification>
          )}
          {(busQuery.data?.[0]?.lastbackupdate ?? '') != '' && (
            <Notification
              id='backup_message'
              disallowClose
              icon={<FaSkullCrossbones size={18} />}
              color='red'
              title='Backup Warning'
            >
              <pre
                id='cla_backupwarn'
                style={{ width: '100%', overflow: 'auto' }}
              >
                No recent backups found, last backup{' '}
                {busQuery.data?.[0]?.lastbackupdate}
              </pre>
            </Notification>
          )}

          {(busQuery.data?.[0]?.licenced ?? 0) > 50 && (
            <Notification
              id='test_message'
              disallowClose
              icon={<GrTestDesktop size={18} />}
              color='orange'
              title='Test System'
            >
              <pre
                id='cla_testwarn'
                style={{ width: '100%', overflow: 'auto' }}
              >
                You are currently working on a test system.
              </pre>
            </Notification>
          )}
          {(busQuery.data?.[0]?.currentversion ?? '') != '' && (
            <Notification
              id='upgrade_message'
              disallowClose
              icon={<GrUpgrade size={18} />}
              color='orange'
              title='Upgrade Scheduled'
            >
              <pre
                id='cla_upgradesched'
                style={{ width: '100%', overflow: 'auto' }}
              >
                Upgrade
              </pre>
              <a
                onClick={() =>
                  console.log(
                    String.raw`cla:event|openhelp|newest-simplicity-version.html`
                  )
                }
              >
                Click here to view the full changelog
              </a>
            </Notification>
          )}
        </Stack>
      </Card.Section>
    </Card>
  )
}
